/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const NoteCircledIcon = /*#__PURE__*/ createSvgIcon(
  'NoteCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle cx={10} cy={10} r={10} fill="#E8EEF7" />
            <path
              d="M8.645 13.917h3.371a.553.553 0 00.567-.56.55.55 0 00-.161-.401.54.54 0 00-.4-.164H8.65a.553.553 0 00-.567.559.55.55 0 00.162.402.54.54 0 00.4.164zm0-2.25h3.371a.553.553 0 00.567-.56.55.55 0 00-.161-.401.54.54 0 00-.4-.164H8.65a.553.553 0 00-.567.559.55.55 0 00.162.402.54.54 0 00.4.164zm-1.691 4.5c-.31 0-.574-.11-.793-.33a1.087 1.087 0 01-.328-.795v-9.75c0-.31.11-.575.33-.795.221-.22.486-.33.795-.33h4.406a1.08 1.08 0 01.797.328l2.344 2.343a1.08 1.08 0 01.328.797v7.407c0 .309-.11.574-.33.794-.22.22-.486.33-.795.33H6.954zm4.13-8.813V5.292H6.957v9.75h6.75V7.917h-2.062a.544.544 0 01-.401-.162.544.544 0 01-.162-.4z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default NoteCircledIcon;
